
	import { Component, Vue } from 'vue-property-decorator';
	import OnboardStore from '@/store/onboard/onboard';
	import { Observer } from 'mobx-vue';

	@Observer
	@Component
	export default class Onboard extends Vue {
		mounted() {
			this.$state.onboard.onboard();
		}
	}
